<template>
  <IndexHeader />
  <HeaderImage />
  <LeftFilterMenu @sideFilters="udpateSideFilters" />
  <RightBody id="content" @hillockFilters="udpateHillockFilters" @pageChanged="updateCourseListPage" />
</template>

<script>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
// 顶部大图
import HeaderImage from "../components/CourseCenter/HeaderImage";
// 左侧筛选菜单
import LeftFilterMenu from "../components/CourseCenter/LeftFilterMenu";
// 右侧主体
import RightBody from "../components/CourseCenter/RightBody";
import { getCourseList } from "../server/course_center_list";
import { requestToken } from "../common/js/request_token"

export default {
  name: "CourseCenterPage",
  data() {
    return {
      sideFilters: {},
      topFilters: [],
      searchKeyword: "",
      currentPage: 1,
    };
  },
  mounted() {
    if (this.isLogin) {
      if (this.$store.state.searchKeyword != "") {
        this.searchKeyword = this.$store.state.searchKeyword;
      }
      this.fetchCourseList();
    } else {
      this.$router.replace('/login');
    }
  },
  methods: {
    scrollToContent() {
      // 滚动到顶部
      this.$scrollTo("#content");
    },
    async fetchCourseList() {
      let params = this.makeRequestParams();
      let result = await getCourseList(params);
      if (result.total != null) {
        this.$store.commit("updateCourseCenterTotal", result.total);
      }
      if (result.sideFilters != null) {
        this.$store.commit("updateCourseSideFilters", result.sideFilters);
      }
      if (result.topFilters != null) {
        this.$store.commit("updateCourseTopFilters", result.topFilters);
      }
      if (result.list != null) {
        this.$store.commit("updateCourseList", result.list);
      }
      this.scrollToContent();
    },
    udpateHillockFilters(filters) {
      this.topFilters = filters;
      this.fetchCourseList();
    },
    udpateSideFilters(filters) {
      this.sideFilters = filters;
      this.fetchCourseList();
    },
    updateCourseListPage(pageIndex) {
      this.currentPage = pageIndex;
      this.fetchCourseList();
    },
    makeRequestParams() {
      var params = {
        type: [],
        money: [],
        suitableObject: [],
        trainCycle: [],
        scope: "",
        name: this.searchKeyword,
        pageNum: `${this.currentPage}`,
        pageSize: "10"
      };
      if (this.sideFilters.type != null) {
        params.type = [...this.sideFilters.type];
      }
      if (this.sideFilters.money != null) {
        params.money = [...this.sideFilters.money];
      }
      params.suitableObject = [...this.topFilters];
      if (this.sideFilters.period != null) {
        params.suitableObject = [...this.sideFilters.period, ...params.suitableObject];
      }
      if (this.sideFilters.trainCycle != null) {
        params.trainCycle = [...this.sideFilters.trainCycle];
      }
      if (this.sideFilters.other != null) {
        let scopeArray = [...this.sideFilters.other];
        params.scope = scopeArray.length != 0 ? scopeArray[0] : "";
      }
      return params;
    },
  },
  components: {
    IndexHeader,
    HeaderImage,
    LeftFilterMenu,
    RightBody,
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.searchKeyword = this.$route.query.k;
        this.fetchCourseList();
      },
    }
  },
  computed: {
    isLogin: {
      get() {
        return requestToken() !== "";
      }
    }
  },
};
</script>